import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/dashboard.css";

export default function Dashboard() {
  const [entries, setEntries] = useState([]);
  const navigate = useNavigate();
  const [goal, setGoal] = useState(() => Number(localStorage.getItem("pj_goal")) || 2400);
  const [totalSaved, setTotalSaved] = useState(0);

  useEffect(() => {
  const saved = JSON.parse(localStorage.getItem("pj_savings")) || [];
  setEntries(saved);
  const total = saved.reduce((sum, e) => sum + e.amount, 0);
  setTotalSaved(total);
}, []);

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("pj_savings")) || [];
    setEntries(saved);
  }, []);

  const handleDelete = (index) => {
    const updated = entries.filter((_, i) => i !== index);
    setEntries(updated);
    localStorage.setItem("pj_savings", JSON.stringify(updated));
  };

  const handleEdit = (index) => {
    navigate("/savings", { state: { editIndex: index } });
  };

  const getMonthlyTotal = () => {
    const now = new Date();
    const month = now.getMonth();
    const year = now.getFullYear();
    return entries
      .filter((e) => {
        const entryDate = new Date(e.date);
        return (
          entryDate.getMonth() === month && entryDate.getFullYear() === year
        );
      })
      .reduce((sum, e) => sum + e.amount, 0);
  };

  const getAllTimeTotal = () => entries.reduce((sum, e) => sum + e.amount, 0);

  const minWeeklySave = 52;
    const calculateStreak = () => {
    let streak = 0;
    let lastWeek = null;
    entries.forEach((e) => {
        const weekNum = parseInt(e.week.replace("Week ", ""));
        if (e.amount >= minWeeklySave && (lastWeek === null || weekNum === lastWeek + 1)) {
        streak++;
        lastWeek = weekNum;
        } else {
        lastWeek = weekNum;
        }
    });
    return streak;
    };
    const handleExport = () => {
  const dataStr = JSON.stringify(entries, null, 2);
  const blob = new Blob([dataStr], { type: "application/json" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = "pocket_journal_savings.json";
  a.click();
  URL.revokeObjectURL(url);
};
useEffect(() => {
  const total = entries.reduce((sum, e) => sum + e.amount, 0);
  setTotalSaved(total);
}, [entries]);


  return (
    <div className="dashboard-container">
      {/* Navigation */}
      <div className="nav-buttons">
        <button onClick={() => navigate("/home")}>🏠 Home</button>
        <button onClick={() => navigate("/savings")}>💰 Savings</button>
      </div>

      <h1>Dashboard</h1>

      <div className="totals">
        <p>Monthly Total: <strong>₹{getMonthlyTotal()}</strong></p>
        <p>All-Time Total: <strong>₹{getAllTimeTotal()}</strong></p>
      </div>

      <div className="goal-container">
  <label>Yearly Goal (₹)</label>
  <input
    type="number"
    value={goal}
    onChange={(e) => {
      const val = Number(e.target.value);
      setGoal(val);
      localStorage.setItem("pj_goal", JSON.stringify(val));
    }}
  />
  <div className="progress-bar">
    <div
      className="progress"
      style={{ width: `${Math.min((totalSaved / goal) * 100, 100)}%` }}
    ></div>
  </div>
  <p>Saved ₹{totalSaved} of ₹{goal}</p>

  {totalSaved >= goal && (
    <p className="congrats-msg">🎉 Congratulations! You’ve reached your goal! 🏆</p>
  )}

  <div className="streak-card">
  <p>Weekly Streak: {calculateStreak()} weeks 🔥</p>
</div>

</div>

      <h2 className="history-title">All Entries</h2>

      <div className="entries">
        {entries.length === 0 && <p>No entries yet.</p>}

        {entries.map((e, i) => (
          <div key={i} className="entry-card">
            <div className="row">
              <strong>₹{e.amount}</strong>
              <span>{e.week}</span>
            </div>
            <small>{e.date}</small>
            {e.emotion && <p>🧠 {e.emotion}</p>}
            {e.note && <p>✨ {e.note}</p>}

            <div className="entry-actions">
              <button className="edit-btn" onClick={() => handleEdit(i)}>
                ✏️ Edit
              </button>
              <button className="delete-btn" onClick={() => handleDelete(i)}>
                🗑️ Delete
              </button>
            </div>
          </div>
        ))}
      </div>
      <button className="export-btn" onClick={handleExport}>📤 Export Data</button>
    </div>
  );
}
